import type { MutableRefObject } from 'react'
import { useEffect } from 'react'
import { render } from 'react-dom'

import { faAngleDown } from '@fortawesome/pro-light-svg-icons/faAngleDown'
import { dark, light } from '@hotmart/space-lib/dist/styles/themes'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import { css } from 'styled-components'
import { useUser } from 'src/hook/useUser'
import { ChevronIcon } from 'src/components/chevronIcon'

const arrowStyles = css`
  .hot-collapse__arrow:hover {
    background-color: var(--gray-200) !important;
    border-radius: var(--border-radius) !important;
  }
`

export function useShadowRef(
  shadowRootRef: MutableRefObject<HTMLElement> | null,
  isActive = false
) {
  const { theme } = useUser()
  useEffect(() => {
    if (shadowRootRef?.current) {
      const shadowRootSelect = shadowRootRef.current.shadowRoot
      const collapseArrow = shadowRootSelect?.querySelector(
        '.hot-collapse__arrow'
      ) as HTMLDivElement
      const collapsedTitle = shadowRootSelect?.querySelector(
        '.hot-collapse__title'
      ) as HTMLDivElement

      const arrowStyle = document.createElement('style')

      arrowStyle.innerHTML = arrowStyles.toString()
      collapseArrow.prepend(arrowStyle)

      collapseArrow.style.backgroundImage = 'none'
      collapseArrow.style.width = '1.813rem'
      collapseArrow.style.height = '1.813rem'
      collapseArrow.style.display = 'flex'
      collapseArrow.style.marginLeft = '0'
      collapseArrow.style.padding = '0.406rem'
      collapseArrow.style.color =
        theme === ThemeMode.DARK ? dark.colors.gray900 : light.colors.gray900
      collapsedTitle.style.paddingRight = '0'

      render(<ChevronIcon icon={faAngleDown} $isActive={isActive} />, collapseArrow)
    }
  }, [shadowRootRef, isActive, theme])

  return { shadowRootRef }
}
